<template>
  <!-- 公用-页头导航 -->
  <div>
    <div class="index-iheader">
      <router-link class="iheader-logobox" target="_blank" to="/">
        <img class="logobox-img" src="@/assets/images/logo_baotou.png" />
      </router-link>
      <div class="iheader-imenubox">
        <el-menu :default-active="activeIndex" class="el-menu-demo imenu-menubox" mode="horizontal">
          <el-menu-item index="1">
            <router-link class="work-nav-a" to="/">首页</router-link>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">数据服务</template>
            <router-link class="work-nav-a" to="/patent/search">
              <el-menu-item index="2-1">专利搜索</el-menu-item>
            </router-link>
            <router-link class="work-nav-a" to="/brand/search">
              <el-menu-item index="2-2">商标搜索</el-menu-item>
            </router-link>
            <router-link class="work-nav-a" to="/rankinglist/index">
              <el-menu-item index="2-3">排行榜</el-menu-item>
            </router-link>
            <div class="work-nav-a" @click="goPower('/monitor/index')">
              <el-menu-item index="2-4">监控追踪</el-menu-item>
            </div>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">运营服务</template>
            <div class="work-nav-a" @click="goPower('/requirement/index')">
              <el-menu-item index="3-1">运营需求对接</el-menu-item>
            </div>
            <router-link class="work-nav-a" to="/serviceorg/index">
              <el-menu-item index="3-2">运营服务机构</el-menu-item>
            </router-link>
            <div class="work-nav-a" @click="jumpExternalLinksHandle('https://www.patentnavi.org.cn/')">
              <el-menu-item index="3-3">专利导航</el-menu-item>
            </div>
            <div class="work-nav-a" @click="jumpExternalLinksHandle('https://btzz.7ipr.com/')">
              <el-menu-item index="3-3">智能装备制造产业专利专题数据库</el-menu-item>
            </div>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">融资服务</template>
            <router-link class="work-nav-a" :to="'/selftest/index?name=' + this.$store.state.logininfo.name">
              <el-menu-item index="4-1">资质自测</el-menu-item>
            </router-link>
            <!-- <div class="work-nav-a" @click="goSelftestPage">
              <el-menu-item index="4-1">资质自测</el-menu-item>
            </div> -->
            <div class="work-nav-a" @click="goPower('/demand/index')">
              <el-menu-item index="4-2">融资需求对接</el-menu-item>
            </div>
            <router-link class="work-nav-a" to="/financing/serviceindex">
              <el-menu-item index="4-3">融资服务机构</el-menu-item>
            </router-link>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">智慧监管</template>
            <router-link class="work-nav-a" to="/network/index">
              <el-menu-item index="5-1">网络监管</el-menu-item>
            </router-link>
            <div class="work-nav-a" @click="goAdminPower('/infringfake/index')">
              <el-menu-item index="5-2">侵权假冒监测</el-menu-item>
            </div>
          </el-submenu>
          <!-- 帮助-导航 -->
          <el-submenu index="6">
            <template slot="title">帮助</template>
            <router-link class="work-nav-a" to="/help/guild">
              <el-menu-item class="work-nav-a" index="6-1">快速上手指引</el-menu-item>
            </router-link>
            <router-link class="work-nav-a" to="/help/knownsearch">
              <el-menu-item class="work-nav-a" index="6-2">知产搜索与监控追踪</el-menu-item>
            </router-link>
            <router-link class="work-nav-a" to="/help/leaderboard">
              <el-menu-item class="work-nav-a" index="6-3">机构与人才榜单</el-menu-item>
            </router-link>
            <router-link class="work-nav-a" to="/help/pledgeservice">
              <el-menu-item class="work-nav-a" index="6-4">运营及质押融资服务</el-menu-item>
            </router-link>
            <router-link class="work-nav-a" to="/help/intellsupervise">
              <el-menu-item class="work-nav-a" index="6-5">智慧监管功能</el-menu-item>
            </router-link>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <!-- 权限不足弹窗 -->
    <el-dialog title="" :visible.sync="powerDialogShow" width="500px">
      <span class="viewpop-viewtitle">权限不足</span>
      <div class="dialog-info">
        <p>只有审核通过的本地机构用户才能享受本项增值服务。</p>
        <p>若您是包头市本地机构，请点击下方按钮填写信息，并提交审核。</p>
      </div>
      <div class="viewpop-viewbtn">
        <router-link to="/user/info">
          <el-button class="viewbtn-btnstyle viewbtn-replybtn viewbtn-replybtn-active" type="primary">去填写</el-button>
        </router-link>
        <el-button class="viewbtn-btnstyle viewbtn-delbtn" type="primary" @click="powerDialogShow = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 管理员用户权限弹窗 -->
    <el-dialog title="" :visible.sync="adminDialogShow" width="350px">
      <span class="viewpop-viewtitle">权限不足</span>
      <div class="dialog-info">
        <p>只有管理员用户才能使用本项功能！</p>
      </div>
      <div class="viewpop-viewbtn">
        <el-button class="viewbtn-btnstyle viewbtn-delbtn" type="primary" @click="powerDialogShow = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      trued: true,
      isAdmin: false,
      powerDialogShow: false, // 权限不足的弹框
      adminDialogShow: false // 管理员权限弹窗
    }
  },
  props: {
    activeIndex: {
      type: String,
      default() {
        return '1'
      }
    }
  },
  created() { },
  methods: {
    goMonitor(urls) {
      // 跳转监控追踪页面之前-判断是否登录
      this.$axios({
        method: 'get',
        url: '/service/user/userinfo',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((res) => {
          this.$router.push(urls)
        })
        .catch((err) => {
          if (err.response.status == 401) {
            // 显示登录弹框
            let showLogin = this.$store.state.showLogin
            this.$store.commit('changeShowLogin', !showLogin)
          }
        })
    },
    // 未登录或普通用户禁止跳转页面
    goPower(url) {
      this.$axios({
        method: 'get',
        url: '/service/user/userinfo',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((res) => {
          let data = res.data.data
          console.log(data.user_category)
          // 如果用户角色为本地用户或者管理员并且绑定企业不为空，则可以跳转进入对应页面
          if ((data.user_category == 2 || data.user_category == 3) && data.institution != '') {
            sessionStorage.setItem('getOperInfo', {})
            sessionStorage.setItem('getInfo', {})
            this.$router.push(url)
          } else {
            // 否则显示“权限不足”弹框
            this.powerDialogShow = true
          }
        })
        .catch((err) => {
          console.log(err)
          if ((err.response && err.response.status && err.response.status == 401) || err == 401) {
            // 未登录则提示登录框
            // 显示登录弹框
            let showLogin = this.$store.state.showLogin
            this.$store.commit('changeShowLogin', !showLogin)
          }
        })
    },
    // 跳转外部链接
    jumpExternalLinksHandle(href) {
      window.open(href, '_blank')
    },
    // 管理员用户权限
    goAdminPower(url) {
      this.$axios({
        method: 'get',
        url: '/service/user/userinfo',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((res) => {
          let data = res.data.data
          console.log(data.user_category)
          if (data.user_category == 3) {
            this.$router.push(url)
          } else {
            this.adminDialogShow = true
          }
        })
        .catch((err) => {
          console.log(err)
          if ((err.response && err.response.status && err.response.status == 401) || err == 401) {
            // 未登录则提示登录框
            // 显示登录弹框
            let showLogin = this.$store.state.showLogin
            this.$store.commit('changeShowLogin', !showLogin)
          }
        })
    }
    // goSelftestPage () { // 跳转资质自测页
    //   console.log('跳转页面')
    //   this.$router.push({
    //     name: '/selftest/index',
    //     params: {
    //       name: this.$store.state.logininfo.name
    //     }
    //   })
    // }
  }
}
</script>
<style scoped>
/* 弹窗 */
:deep(.el-dialog__header) {
  display: none !important;
}

:deep(.el-dialog__body) {
  padding: 40px;
  text-align: left;
}

.viewpop-viewtitle {
  display: block;
  text-align: center;
  line-height: 22px;
  color: #d42a2a;
  font-weight: 700;
  font-size: 16px;
}

.dialog-info {
  margin: 20px 0;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.dialog-info p {
  line-height: 20px;
  margin-bottom: 5px;
}

.viewpop-viewbtn {
  margin-top: 15px;
  display: -webkit-flex;
  /* Safari */
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}

.viewbtn-integral {
  margin-right: 20px;
  display: flex;
  align-items: center;
  color: #d42a2a;
  font-size: 12px;
}

.viewbtn-integral>p {
  font-weight: bold;
  margin-right: 20px;
  text-align: left;
}

.viewbtn-btnstyle {
  padding: 0;
  width: 100px;
  height: 30px;
  line-height: 30px;
  background: #d42a2a;
  border: 1px solid #d42a2a;
  border-radius: 4px;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 12px;
}

.advbtn-replybtn:hover {
  background: #dddddd;
  border: 1px solid #dddddd;
  color: #ffffff;
}

.viewbtn-replybtn-active {
  background: #d42a2a;
  border: 1px solid #d42a2a;
  margin-right: 15px;
}

.viewbtn-delbtn {
  background: #ffffff;
  border: 1px solid #d42a2a;
  color: #d42a2a;
}
</style>
<style>
.index-iheader {
  margin: 0 auto;
  padding: 0 0px;
  /* padding: 0 20px; */
  max-width: 1440px;
  height: 90px;
  box-sizing: border-box;
  text-align: left;
}

.index-iheader::after {
  display: block;
  content: '';
  clear: both;
}

.iheader-logobox {
  display: block;
  float: left;
  margin: 10px 0;
}

.logobox-img {
  max-width: 510px;
  width: auto;
  height: 70px;
}

/* 导航 */
.iheader-imenu {
  float: right;
  overflow: hidden;
}

.imenu-menuli {
  float: left;
  margin-right: 40px;
  padding: 30px 0;
  /* width: 64px; */
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #050162;
  font-weight: 700;
  font-size: 17px;
  cursor: pointer;
}

.imenu-menuli:last-child {
  margin-right: 0;
}

.imenu-menuli.imenu-menuli-active {
  color: rgb(26, 85, 248);
}

/* 导航 */
.iheader-imenubox {
  float: right;
  padding: 15px 0;
  height: 90px;
  box-sizing: border-box;
}

.iheader-imenubox .el-menu.el-menu--horizontal {
  border-bottom: none;
}

.iheader-imenubox .el-menu--horizontal>.el-menu-item {
  float: left;
  margin-right: 40px;
  padding: 0;
  height: 60px;
  line-height: 60px;
  border-bottom: none !important;
  text-align: center;
  /* color: #050162; */
  color: #d42a2a !important;
  font-weight: 700;
  font-size: 17px;
  cursor: pointer;
}

.iheader-imenubox .el-menu--horizontal>.el-menu-item:last-child {
  margin-right: 0;
}

.iheader-imenubox .el-menu--horizontal>.el-menu-item:hover {
  color: #d42a2a;
}

.el-menu--horizontal .el-menu .el-menu-item {
  color: #d42a2a !important;
  font-weight: 700;
}

.iheader-imenubox .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none;
  color: #d42a2a;
}

.iheader-imenubox .el-submenu__title {
  padding: 0;
}

.iheader-imenubox .el-submenu {
  float: left;
  margin-right: 40px;
  padding: 0;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
}

.iheader-imenubox .el-submenu .el-submenu__title {
  border-bottom: none !important;
  /* color: #050162; */
  color: #d42a2a !important;
  font-weight: 700;
  font-size: 17px;
}

.el-menu--horizontal>.el-submenu.is-opened .el-submenu__title {
  color: #d42a2a;
}

.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
  color: #d42a2a !important;
}

.iheader-imenubox .el-submenu .el-icon-arrow-down:before {
  content: '';
}

.work-nav-a {
  display: block !important;
  color: #d42a2a !important;
}

.el-menu.el-menu--popup .el-menu-item:hover {
  color: #d42a2a;
}

/* 鼠标样式禁止点击 */
.noallow {
  cursor: not-allowed;
}
</style>
